/**
 * Trademark page — search + category filter.
 *
 * Markup contract (page-trademark.php):
 *   [data-trademark-cards]   → the grid wrapper
 *   [data-trademark-card]    → a single card
 *   [data-trademark-search]  → the search input
 *   [data-trademark-cat]     → a category pill (button)
 *   [data-trademark-count]   → "SHOWING X OF Y" status span
 *   [data-trademark-empty]   → the empty-state block (already `hidden`)
 *
 * Each card carries:
 *   data-cats="connectivity,instrumentation"  (lower-case, comma list)
 *   data-search="anybus hms gateway profinet"  (lower-case haystack)
 *
 * Filtering toggles the `hidden` attribute on each card; layout stays
 * grid-correct because hidden items collapse out of the flow.
 */

const CARDS_SELECTOR    = '[data-trademark-cards]';
const CARD_SELECTOR     = '[data-trademark-card]';
const SEARCH_SELECTOR   = '[data-trademark-search]';
const CAT_SELECTOR      = '[data-trademark-cat]';
const COUNT_SELECTOR    = '[data-trademark-count]';
const EMPTY_SELECTOR    = '[data-trademark-empty]';

const initTrademarkFilter = () => {
    const wrap = document.querySelector(CARDS_SELECTOR);
    if (!wrap) return;

    const cards   = Array.from(wrap.querySelectorAll(CARD_SELECTOR));
    if (cards.length === 0) return;

    const search  = document.querySelector(SEARCH_SELECTOR);
    const pills   = Array.from(document.querySelectorAll(CAT_SELECTOR));
    const count   = document.querySelector(COUNT_SELECTOR);
    const empty   = document.querySelector(EMPTY_SELECTOR);
    const total   = cards.length;

    // The "SHOWING X OF Y" template is rendered server-side using the
    // current locale's translation. We need the same template so we can
    // re-render the X part as cards filter — read it from the DOM once
    // and treat the two integers as positional placeholders.
    const countTemplate = count ? count.textContent.trim() : '';

    let activeCat = 'All';
    let query     = '';

    const formatCount = (n) => {
        if (!countTemplate) return '';
        // Replace the first two integer runs with [n, total]. Avoids
        // hard-coding "SHOWING X OF Y" English.
        let i = 0;
        return countTemplate.replace(/\d+/g, () => (i++ === 0 ? String(n) : String(total)));
    };

    const apply = () => {
        const q = query.trim().toLowerCase();
        const cat = activeCat.toLowerCase();

        let shown = 0;
        cards.forEach((card) => {
            const cats = (card.getAttribute('data-cats') || '').toLowerCase();
            const hay  = (card.getAttribute('data-search') || '').toLowerCase();

            const catMatch    = cat === 'all' || cats.split(',').includes(cat);
            const searchMatch = !q || hay.includes(q);
            const visible     = catMatch && searchMatch;

            if (visible) {
                card.removeAttribute('hidden');
                shown += 1;
            } else {
                card.setAttribute('hidden', '');
            }
        });

        if (count) count.textContent = formatCount(shown);
        if (empty) {
            if (shown === 0) empty.removeAttribute('hidden');
            else             empty.setAttribute('hidden', '');
        }
    };

    if (search) {
        search.addEventListener('input', (e) => {
            query = e.target.value || '';
            apply();
        });
    }

    pills.forEach((pill) => {
        pill.addEventListener('click', () => {
            activeCat = pill.getAttribute('data-trademark-cat') || 'All';
            pills.forEach((p) => {
                const on = p === pill;
                p.classList.toggle('is-active', on);
                p.setAttribute('aria-pressed', on ? 'true' : 'false');
            });
            apply();
        });
    });
};

// Run now if the DOM is already parsed (deferred / delayed script
// execution would otherwise miss DOMContentLoaded and never init).
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTrademarkFilter);
} else {
    initTrademarkFilter();
}
